import script from "./RGBGhostEffect.vue?vue&type=script&setup=true&lang=js"
export * from "./RGBGhostEffect.vue?vue&type=script&setup=true&lang=js"

import "./RGBGhostEffect.vue?vue&type=style&index=0&id=810113ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-810113ee"]])

export default __exports__